import { Guid } from "src/interfaces/InleagueApiV1";

export const MAXLEN_DIVISION = 50
export const MAXLEN_DISPLAYNAME = 50

export const NEWDIV = "new";
export type MaybeDivIdOrNew = "" | typeof NEWDIV | Guid;
